const MandatoryAsterisk = () => {
  return <span className="red-text fw-bold">*</span>;
};

export default MandatoryAsterisk;
